import type React from 'react';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export const Photo: React.FC<Props> = ({ id, url, mobileUrl }) => {
	return (
		<picture>
			<source srcSet={mobileUrl} media="(max-width: 767px)" />
			{/* The ratio we generate from uploaded images is 25/14; align-top removes unwanted padding under the image */}
			<img
				fetchPriority="high"
				id={id}
				src={url}
				alt=""
				className="rounded-large aspect-[25/14] w-full object-cover align-top"
			/>
		</picture>
	);
};
